import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  orderId: string;
};

export async function rejectOrderApi({ orderId }: Data) {
  return makeRequest(Service.rejectOrder(orderId, await identify()));
}
